import React from 'react';
import MDReactComponent from 'markdown-react-js';

import './FlexibleHeader.scss';

export default props => {
  const { data: { imagedefault, imagelarge, title, standfirst }, imageAlt} = props;
  let imageExists;
  let imageToLoad;
  if (imagelarge || imagedefault) {
    imageExists = imagelarge.src || imagedefault.src;
    imageToLoad = window.innerWidth < 600 ? imagedefault.src : imagelarge.src;
  }

  return (
    <header className='FlexibleHeader'>
      <div className='FlexibleHeader__image-container'>
        <div className='FlexibleHeader__image-overlay' />
        {imageToLoad && (
          <img
            className='FlexibleHeader__image'
            src={imageToLoad}
            alt={imageAlt}
          />
        )}
        <div
          className={`FlexibleHeader-text FlexibleHeader-text${
            imageExists ? '--image' : ''
          }`}
        >
          <h1 className='FlexibleHeader-heading'>{title}</h1>
          <div
            className={`FlexibleHeader-subheading ${
              imageExists ? '' : 'FlexibleHeader-subheading--small'
            }`}
          >
            <MDReactComponent text={standfirst.toUpperCase()} />
          </div>
        </div>
      </div>
    </header>
  );
};



// WEBPACK FOOTER //
// ./src/components/organisms/FlexibleHeader/index.js